import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforGetOn {
  // testName: string
  // pageState: boolean
  // pageStateChangeTime: null
  checked_IsSumWeight:Boolean
  checked_IsOverTimeCar: Boolean
  checked_AutoCreateCarCode: Boolean
  checked_NeedWeight: Boolean
  nextorgoptions:Array<any>;
  checked_AutoCreateCarCodeOld: Boolean

}

@Module({ dynamic: true, store, name: 'store_scanforgeton' })
class ScanforGetOn extends VuexModule implements IScanforGetOn {
  // public pageState = false
  // public pageStateChangeTime = null
  // public testName = ''
  public checked_IsSumWeight = false;
  public checked_IsOverTimeCar = false;
  public checked_AutoCreateCarCode = false;
  public checked_NeedWeight = false;
  public nextorgoptions = [];

  public checked_AutoCreateCarCodeOld = false;

  @Mutation
  public IsSumWeightChangeState(state) {
    this.checked_IsSumWeight = state;
    // this.pageState = flag;
    // this.pageStateChangeTime =Date.now();
  }
  @Mutation
  public IsOverTimeCarChangeState(state) {
    this.checked_IsOverTimeCar = state;
    // this.pageState = flag;
    // this.pageStateChangeTime =Date.now();
  }
  @Mutation
  public AutoCreateCarCodeChangeState(state) {
    this.checked_AutoCreateCarCode = state;
    // this.pageState = flag;
    // this.pageStateChangeTime =Date.now();
  }
  @Mutation
  public NeedWeightChangeState(state) {
    this.checked_NeedWeight = state;
    // this.pageState = flag;
    // this.pageStateChangeTime =Date.now();
  }
  //下一网点优化，实现双向传值
  @Mutation
  public NextOrgOptionsSet(list) {
    this.nextorgoptions = list;
  }

  @Mutation
  public AutoCreateCarCodeOldChangeState(state) {
    this.checked_AutoCreateCarCodeOld = state;
  }


  // @Action
  // public async GetUserInfo() {
  //     const name = "data.user";
  // }

}

export const ScanforGetOnModule = getModule(ScanforGetOn)
